module.exports = __webpack_public_path__ + "static/img/productd_img4@2x.ec9ee177.jpg";